import cn from "classnames"
import React from "react"

import { RouterLink } from "~/components/RouterLink/RouterLink"
import { useSetState } from "~/services/useSetState"

import styles from "./index.module.css"

export const StyledLink = ({
  children,
  // из документации next.js
  // as: the path that will be rendered in the browser URL bar.
  as = undefined,
  // href: the path inside pages directory.
  href = undefined,
  asComponent = undefined,
  className = undefined,
  isOnDark = undefined,
  isOnYellow = undefined,
  ...props
}) => {
  const Component = asComponent || RouterLink
  const [{ hovered, timeout }, setState] = useSetState({ hovered: false, timeout: false })

  const onMouseEnter = () => {
    if (timeout) {
      return
    }
    setState({ hovered: true, timeout: true })
    setTimeout(() => setState({ timeout: false }), 440)
  }

  const onMouseLeave = () => setState({ hovered: false })

  return (
    <Component
      as={as}
      className={cn(
        styles.Link,
        className,
        { [styles.Hover]: hovered || timeout },
        { [styles.LinkOnDark]: isOnDark },
        { [styles.LinkOnYellow]: isOnYellow },
      )}
      href={href}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...props}
    >
      {children}
    </Component>
  )
}
